import { API_BASE } from 'shared/constants/Api'
export const ARTICLE_LIST = `${API_BASE}/api/v2/articles/`
export const ARTICLE_INFO = `${API_BASE}/api/v2/articles/`
